import DestinationInfo from './DestinationInfo';

export default DestinationInfo;
